import React, { FC } from 'react';
import classnames from 'classnames';
import styles from './list-item.style.less';

interface IProps {
  label: React.ReactNode;
  children?: React.ReactNode;
  subChildren?: React.ReactNode;
  className?: string;
}

const ListItem: FC<IProps> = ({ label, children, className, subChildren }) => {
  return (
    <>
      <div
        className={classnames([
          styles.container,
          { [className as string]: !!className },
        ])}
      >
        <span className={styles.text}>{label}</span>
        {typeof children !== 'undefined' && (
          <span className={styles.text}>{children}</span>
        )}
      </div>
      {subChildren && <div className={styles.subChildren}>{subChildren}</div>}
    </>
  );
};

export default ListItem;
